import { FORMS_ID } from "application/constants/app-constants";

import getCountry from "./getCountry";
import { find, toUpper, keys } from "ramda";

export default function getRegion() {
  const country = getCountry();
  const countryKeys = keys(FORMS_ID);
  const region = find((k) => k === country, countryKeys);
  if (region) return toUpper(region);

  return "GB";
}
